export default __webpack_public_path__ + "static/media/diamond.7d1b4dd5.svg";